// src/components/order/AdditionalLineItemsSection.jsx
import React from 'react'
import { CFormSelect } from '@coreui/react'

const AdditionalLineItemsSection = ({
  items, // inputList.other_line_items
  lineItems, // full list of line-item types from props
  skuLocation, // skuLocation lookup
  errorList, // form validation errors
  onAdd, // handler to add a new row
  onRemove, // handler to remove row (e, index)
  onChange, // handler to update any field (e, index)
  onBlurDecimal, // handler to format decimals (e, index, arrayName)
}) => {
  // find the Fuel Levy ID once
  const fuelLevyId = lineItems.find((li) => li.name === 'Fuel Levy')?.id

  return (
    <div className="mb-4">
      <div className="d-flex mb-3">
        <h4>Additional Line Items</h4>
        <button className="btn btn-success ms-2" onClick={onAdd}>
          Add Line Item
        </button>
      </div>
      <table className="table table-bordered table-striped">
        {items.length > 0 && (
          <thead>
            <tr>
              <th>Type</th>
              <th>Xero Code</th>
              <th>Description</th>
              <th>Location</th>
              <th>Division</th>
              <th>Quantity</th>
              <th>Amount</th>
              <th>Total</th>
              <th>Actions</th>
            </tr>
          </thead>
        )}
        <tbody>
          {items.map((item, i) => {
            const isFuelLevy = Number(item.type) === fuelLevyId
            return (
              <tr key={i}>
                <td>
                  <CFormSelect name="type" value={item.type} onChange={(e) => onChange(e, i)}>
                    <option value="">— select —</option>
                    {lineItems.map((li) => (
                      <option key={li.id} value={li.id}>
                        {li.name}
                      </option>
                    ))}
                  </CFormSelect>
                  <div className="text-danger">{errorList[`other_line_items.${i}.type`]}</div>
                </td>
                <td>
                  <input
                    className="form-control"
                    name="xero_code"
                    value={item.xero_code}
                    disabled
                  />
                  <div className="text-danger">{errorList[`other_line_items.${i}.xero_code`]}</div>
                </td>
                <td>
                  <input
                    className="form-control"
                    name="description"
                    value={item.description}
                    onChange={(e) => onChange(e, i)}
                  />
                  <div className="text-danger">
                    {errorList[`other_line_items.${i}.description`]}
                  </div>
                </td>
                <td>
                  <CFormSelect
                    name="sku_location"
                    value={item.sku_location}
                    onChange={(e) => onChange(e, i)}
                  >
                    <option value="">— select —</option>
                    {skuLocation.map((loc) => (
                      <option key={loc.id} value={loc.id}>
                        {loc.name}
                      </option>
                    ))}
                  </CFormSelect>
                </td>
                <td>
                  <CFormSelect
                    name="division"
                    value={item.division}
                    onChange={(e) => onChange(e, i)}
                  >
                    <option value="">— select —</option>
                    <option value="1">Spreading</option>
                    <option value="2">Transport</option>
                    <option value="3">Mining</option>
                  </CFormSelect>
                </td>
                <td>
                  <input
                    className="form-control"
                    name="quantity"
                    type="number"
                    step="any"
                    value={item.quantity}
                    onChange={(e) => onChange(e, i)}
                    onBlur={(e) => onBlurDecimal(e, i, 'other_line_items')}
                  />
                  <div className="text-danger">{errorList[`other_line_items.${i}.quantity`]}</div>
                </td>
                <td>
                  <input
                    className="form-control"
                    name="amount"
                    type="number"
                    step="any"
                    value={item.amount}
                    onChange={(e) => onChange(e, i)}
                    onBlur={(e) => onBlurDecimal(e, i, 'other_line_items')}
                    disabled={isFuelLevy}
                  />
                  <div className="text-danger">{errorList[`other_line_items.${i}.amount`]}</div>
                </td>
                <td>
                  <input
                    className="form-control"
                    value={(Number(item.quantity) * Number(item.amount)).toFixed(3)}
                    disabled
                  />
                </td>
                <td>
                  {/*  {i === items.length - 1 && (
                    <button className="btn btn-success btn-sm me-2" onClick={onAdd}>
                      Add
                    </button>
                  )} */}
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={(e) => {
                      e.preventDefault()
                      onRemove(e, i)
                    }}
                  >
                    Remove
                  </button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default AdditionalLineItemsSection
